import OpenAI from "openai";
import { postHistoric } from "../postHistoric";
import formatDate from "../../utils/formatDate";
import { getCSRF } from "../getCSRF";
import Cookies from 'js-cookie'
import backEnd from "../../constants/backEnd";
import endpoints from "../../constants/endpoints";


async function consumeSSEStream(response, { onDelta, onEvent, onDone, submitRef, signal }) {
  if (!response?.body || typeof response.body.getReader !== "function") {
    throw new Error("Resposta não possui body stream legível.");
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";

  const flushEventBlock = async (rawBlock) => {
    // Normaliza quebras de linha para \n
    const block = rawBlock.replace(/\r\n/g, "\n");
    const lines = block.split("\n");

    let eventName = null;
    const dataParts = [];

    for (const line of lines) {
      if (!line || line.startsWith(":")) continue; // comentário ou vazio
      if (line.startsWith("event:")) {
        eventName = line.slice(6).trim();
      } else if (line.startsWith("data:")) {
        dataParts.push(line.slice(5).trim());
      }
      // Linhas "id:" e "retry:" podem aparecer em SSE; ignoramos
    }

    const dataStr = dataParts.join("\n");
    if (!dataStr) return;

    if (dataStr === "[DONE]") {
      try { onDone && onDone(); } catch (_) {}
      return "DONE";
    }

    // Tenta parsear JSON; se não for JSON, ignore silenciosamente (ou logue)
    let payload;
    try {
      payload = JSON.parse(dataStr);
    } catch {
      // Alguns servidores podem enviar linhas de log não-JSON
      // console.warn("SSE non-JSON data:", dataStr);
      return;
    }

    // Dispara evento nomeado (se houver)
    if (eventName && typeof onEvent === "function") {
      try { onEvent(eventName, payload); } catch (_) {}
    }

    // Delta de texto
    if (payload && payload.type === "delta" && typeof payload.content === "string") {
      try { onDelta && onDelta(payload.content); } catch (_) {}
    }

    // Erro
    if (payload && payload.type === "error") {
      // Você pode também chamar onEvent("error", payload)
      // console.error("SSE error:", payload);
    }
  };

  try {
    while (true) {
      if (signal?.aborted || (submitRef && submitRef.current === false)) {
        try { reader.cancel(); } catch (_) {}
        break;
      }

      const { value, done } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });

      // Eventos SSE são separados por uma linha em branco (\n\n)
      let sepIndex;
      while ((sepIndex = buffer.indexOf("\n\n")) !== -1) {
        const eventChunk = buffer.slice(0, sepIndex);
        buffer = buffer.slice(sepIndex + 2);

        const res = await flushEventBlock(eventChunk);
        if (res === "DONE") {
          try { reader.cancel(); } catch (_) {}
          return;
        }
      }
    }

    // Processa o que sobrou (sem \n\n final)
    if (buffer.trim()) {
      const res = await flushEventBlock(buffer);
      if (res === "DONE") return;
    }
  } finally {
    try { reader.releaseLock(); } catch (_) {}
  }
}


const openAIAssistant = async (api, message, idAsssistent, setReturnText, send, updateHistoric, model='') => {

    const submitRef = { current: true }; // referência mutável para permitir cancelamento
    const controller = new AbortController();

    

    try {
        const csrf = await getCSRF();

        if (model===''){
            model = 'gpt-4o-2024-11-20';
        }
        const payload = {
            assistant_id: idAsssistent,
            model,
            messages: [
                { role: "user", content: message },
            ],
        };


        const session = Cookies.get('airton@data') && JSON.parse(Cookies.get('airton@data'))

        const res = await fetch(`${backEnd.url}${endpoints.openai.assistant}`, {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${session.token}`,
            "Content-Type": "application/json",
            "X-CSRFToken": csrf?.csrfToken,
            "Accept": "text/event-stream, application/json;q=0.9, /;q=0.1"
        },
        body: JSON.stringify(payload),
        signal: controller.signal,
        credentials: "include", // garante envio de cookies (CSRF, session) se necessário
        });

        console.log("Fetch iniciado:", res);
        if (!res.ok) {
        const errText = await res.text().catch(() => "");
        throw new Error(`HTTP ${res.status} - ${errText || res.statusText}`);
        }

        let finalText = "";
        const initialText = "";

        await consumeSSEStream(res, {
        signal: controller.signal,
        submitRef,
        onEvent: (evt, data) => {
            // Ex.: evt === "meta" com { max_tokens: ... }
            // console.log("SSE event:", evt, data);
        },
        onDelta: (deltaText) => {
            console.log(deltaText)
            if (!submitRef.current) {
            controller.abort();
            return;
            }
            if (finalText === "") {
            finalText = initialText + deltaText;
            } else {
            finalText += deltaText;
            }
            setReturnText(finalText);
        },
        onDone: () => {
            // fim do stream
        },
        });

        let historic = {
            send: send,
            text: JSON.stringify([
                { role: "user", content: message },
            ]),
            result: finalText,
            date: formatDate(new Date()),
            action: api,
        }

        await postHistoric(historic)
        updateHistoric.set(finalText);
    } catch (err) {
        if (err?.name === "AbortError") {
        // cancelado
        // console.log("Streaming aborted");
        } else {
        console.error("Erro no streaming:", err);
        // Você pode exibir um erro para o usuário aqui
        }
    }


    
}

export default openAIAssistant